/* The parts every tag surface on this screen shares — the tag boards' `.tag` and `.field`,
 * 10 October 2026.
 *
 * The chip at two sizes over one shape: the theatre's removable 24px chip with its ×, and the
 * table's read-only 20px one. And the 30px field both the theatre's editor and the manage dialog's
 * rename type into. One stylesheet because they are the same objects in three places, and two
 * near-identical blocks in two files is the drift `CLAUDE.md` names. Neutral, and that is the
 * decision: a tag is the trainer's note, not a state, and the accent is spent elsewhere. */

.tag {
  display: inline-flex;
  flex: none;
  gap: var(--space-6px);
  align-items: center;
  max-width: 100%;
  height: 24px;
  padding: var(--space-0) var(--space-6px) var(--space-0) var(--space-10px);
  font-size: var(--fs-micro);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text);
  white-space: nowrap;
  background: var(--bg-sunken);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--r-pill);
}

/* The table's chip: no ×, so the inset is even, and it is the row's quieter size. */
.small {
  height: 20px;
  padding: var(--space-0) var(--space-2);
  font-size: var(--fs-eyebrow);
}

.text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.remove {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: var(--space-0);
  color: var(--text-2);
  background: transparent;
  border: none;
  border-radius: var(--r-circle);
  cursor: pointer;
}

.remove:hover {
  color: var(--text);
  background: var(--hover-tint);
}

.remove:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--space-1px);
}

.remove[aria-disabled='true'] {
  cursor: default;
}

.removeGlyph {
  width: 10px;
  height: 10px;
}

/* ── The field ─────────────────────────────────────────────────────────────────────────────── */

.field {
  display: flex;
  gap: var(--space-6px);
  align-items: center;
  height: 30px;
  padding: var(--space-0) var(--space-10px);
  background: var(--bg-inset);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-8px);
}

.field:focus-within {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--outline-inset);
}

.fieldInput {
  flex: 1;
  min-width: 0;
  padding: var(--space-0);
  font: inherit;
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-auto);
  color: var(--text);
  background: transparent;
  border: none;
  outline: none;
}

.fieldInput::placeholder {
  font-weight: var(--fw-medium);
  color: var(--text-2);
}

/* The quiet words at the field's end: „Enter dodaje", „było: kolano". */
.fieldHint {
  flex: none;
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--lh-auto);
  color: var(--text-2);
  white-space: nowrap;
}
